import FinanceBotV2Dashboard from '../pages/FinanceBotV2Dashboard';

export const FinanceBotV2Section = () => {
  return <FinanceBotV2Dashboard />;
};
